export default __webpack_public_path__ + "static/char-s-16-kr-ee2f4d6a16335022dbed09825d17efe8.png";